module.exports = __webpack_public_path__ + "img/journal-arrow-up.d31d9469.svg";